import api from '../api';
export function chatError(error, fallback) {
  return Object.values(error?.response?.data?.errors || {}).flat()[0] || error?.response?.data?.message || fallback;
}
export function attachmentError(file) {
  if (!file) return '';
  if (file.size > 5 * 1024 * 1024) return 'Attachments must be 5 MB or smaller.';
  if (!['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)) return 'Choose a JPG, PNG, or PDF file.';
  return '';
}
export async function downloadChatAttachment(message) {
  const response = await api.get(`/chat/messages/${message.id}/attachment`, {
    responseType: 'blob',
    params: {
      download: true
    }
  });
  const url = URL.createObjectURL(new Blob([response.data], {
    type: response.headers?.['content-type'] || message.attachment_mime || 'application/octet-stream'
  }));
  const link = document.createElement('a');
  link.href = url;
  link.download = message.attachment_name || 'attachment';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
